module.exports = __webpack_public_path__ + "static/media/bg@2x.a775cb4b.png";